module.exports = __webpack_public_path__ + "static/media/about-bg.9ff6e14d.avif";